import { useState, useCallback } from 'react'

const LS_KEY   = 'jdrivero_catalog_units'
const DEFAULTS = ['ft²', 'ft', 'Unit', 'Units']

function load() {
    try {
        const raw = localStorage.getItem(LS_KEY)
        if (raw) {
            const parsed = JSON.parse(raw)
            if (Array.isArray(parsed) && parsed.length) return parsed
        }
    } catch (_) {}
    return DEFAULTS
}

function persist(list) {
    try { localStorage.setItem(LS_KEY, JSON.stringify(list)) } catch (_) {}
}

/**
 * useUnits — localStorage-backed list of unit-type labels.
 *
 * @returns {{ units: string[], addUnit: (label: string) => void, removeUnit: (label: string) => void }}
 */
export function useUnits() {
    const [units, setUnits] = useState(() => load())

    const addUnit = useCallback((label) => {
        const trimmed = label.trim()
        if (!trimmed) return
        setUnits(prev => {
            if (prev.some(u => u === trimmed)) return prev
            const next = [...prev, trimmed]
            persist(next)
            return next
        })
    }, [])

    const removeUnit = useCallback((label) => {
        setUnits(prev => {
            const next = prev.filter(u => u !== label)
            persist(next)
            return next
        })
    }, [])

    return { units, addUnit, removeUnit }
}
